import { TicketItem } from 'shared/models/ticket'

import { NeedVisaAlert } from '../need-visa-alert'
import { UaeVisaAlert } from '../uae-visa-alert'

interface Props {
  selectedTicket: TicketItem
}

export const VisaInfo = ({ selectedTicket }: Props) => {
  return (
    <>
      {!selectedTicket?.is_uae_visa_necessary &&
        selectedTicket?.is_visa_necessary && <NeedVisaAlert />}

      {selectedTicket?.is_uae_visa_necessary && <UaeVisaAlert />}
    </>
  )
}
